import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { useCart } from "../context/CartContext";
import Navbar from "../components/Nav";
import Footer from "../components/Footer";
import { TailSpin } from "react-loader-spinner"; // Spinner جاهز

const Shop = () => {
  const { addToCart } = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsRef = collection(db, "products");
        const snapshot = await getDocs(productsRef);
        const allProducts = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(allProducts);
      } catch (error) {
        console.error("خطأ أثناء جلب المنتجات:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading)
    return (
      <div style={{
        minHeight: "60vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "20px"
      }}>
        <TailSpin
          height="80"
          width="80"
          color="#5b3a29"
          ariaLabel="loading"
        />
        <p style={{ fontSize: 18, color: "#5b3a29" }}>⏳ جاري تحميل المنتجات...</p>
      </div>
    );

  if (products.length === 0)
    return <p style={{ textAlign: "center", fontSize: 18 }}>لا توجد منتجات متاحة حالياً</p>;

  return (
    <>
      <Navbar />
      <div style={{ padding: "40px", maxWidth: "1200px", margin: "auto" }}>
        <h2 style={{ textAlign: "center", marginBottom: "30px" }}>Shop All Products</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
          {products.map(p => (
            <div key={p.id} style={{ border: "1px solid #ccc", borderRadius: "10px", overflow: "hidden" }}>
              <img src={p.imageUrl} alt={p.name} style={{ width: "100%", height: "220px", objectFit: "cover" }} />
              <div style={{ padding: "15px", textAlign: "center" }}>
                <h3>{p.name}</h3>
                <p style={{ fontWeight: "bold" }}>{p.price} EGP</p>
                <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
                  <button
                    onClick={() => addToCart({ id: p.id, name: p.name, price: p.price, image: p.imageUrl })}
                    style={{ padding: "10px 20px", background: "#5b3a29", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}
                  >
                    Add to Cart
                  </button>
                  <button
                    onClick={() => window.location.href = `/product/${p.id}`}
                    style={{ padding: "10px 20px", background: "#8a8f3a", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer" }}
                  >
                    View Product
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Shop;
